/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";

// Argon Dashboard 2 MUI components
import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";

// Argon Dashboard 2 MUI base styles
import typography from "assets/theme/base/typography";

function Footer({ links = [] }) {
  const { size } = typography;

  const renderLinks = () =>
    links?.map((link) => (
      <Box key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link?.href} target="_blank" rel="noopener noreferrer">
          <Typography variant="button" fontWeight="regular" color="text">
            {link?.name}
          </Typography>
        </Link>
      </Box>
    ));

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        <Typography variant="button" fontWeight="regular" color="text" component="span">
          © Copyright CompCheck.io. All Rights Reserved
        </Typography>
      </Box>
      {links.length > 0 ? (
        <Box
          component="ul"
          sx={({ breakpoints }) => ({
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            listStyle: "none",
            mt: 3,
            mb: 0,
            p: 0,

            [breakpoints.up("lg")]: {
              mt: 0,
            },
          })}
        >
          {renderLinks()}
        </Box>
      ) : null}
    </Box>
  );
}

Footer.defaultProps = {
  links: [],
};

Footer.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
